module.exports = __webpack_public_path__ + "img/2_80.fc870de1.png";